
import { Link, useNavigate } from "react-router-dom";
import "./Errors.css"

function ClientError({ onFocus, value, onChange }) {
    const navigate = useNavigate();
    const reloadPageHandler=()=>{
        navigate(-1)
        window.location.reload()
    }
    return (
        <>
            <div className="flex items-center justify-start w-full h-screen flex-col bg-[#F1F1F1]">
                <img src="/advertiseDetail.gif" alt="" />
                <p className="font-bold text-2xl text-red-500 text-center  mb-4">
                    شما اشتراک این محله را ندارید
                </p>
                {/* <div className="w-full h-[2px] bg-red-200 mt-2"></div> */}
                <div>
                    {/* <button onClick={()=>reloadPageHandler()} className="border-main border-2 rounded-xl px-4 py-1 mt-2 text-center text-main"> */}
                    <a href="/"  className="border-main border-2 rounded-xl px-4 py-1 mt-8 text-center text-main">
                      بازگشت
                    </a >
                    {/* </button> */}
                </div>
            </div>
        </>
    );
}

export default ClientError